import React from 'react'
import AllMoviesPage from '../components/AllMoviesPage'
import Footer from '../components/Footer'
import Navigation from '../components/Navigation'

function AllMovies() {
  return (
    <>
    <Navigation />
    <AllMoviesPage />
    <Footer />
    </>
  )
}

export default AllMovies